import React, { useMemo, useState } from "react";
import PageHeader from "../../../components/common/PageHeader";
import OrderProductsTable from "../../../components/OrderManagement/OrderProductsTable";
import OrderStatusHistory from "../../../components/OrderManagement/OrderStatusHistory";

const OrderDetailView = ({
    selectedOrder,
    setSelectedOrder,
    newStatus,
    setNewStatus,
    statusHistory,
    rows,
    showSubmitButton,
    suggestions,
    deleteIndex,
    setDeleteIndex,
    showDeletePopup,
    setShowDeletePopup,
    selectedReasons,
    setSelectedReasons,
    isFinalStageSelection,
    address,
    setAddress,
    addressOptions,
    driverList,
    driverId,
    setDriverId,
    driverName,
    setDriverName,
    driverMobile,
    setDriverMobile,
    useNewDriver,
    setUseNewDriver,
    reasons,
    handleChange,
    handleSelectSuggestion,
    handleAddRow,
    handleSubmit,
    handleProductDelete,
    getNextStatuses,
    updateOrderStatus,
    activeSuggestionIndex,
    setActiveSuggestionIndex

}) => {
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [selectedRejectReason, setSelectedRejectReason] = useState("");

    const rejectReasons = useMemo(() => (Array.isArray(reasons) ? reasons : []), [reasons]);

    const closeRejectModal = () => {
        setIsRejectModalOpen(false);
        setSelectedRejectReason("");
    };

    return (
        <div>
        <PageHeader
            showBackButton={true}
            onBack={() => setSelectedOrder(null)}
            title="Order Details"
            subtitle={`Order #${selectedOrder.orderId} · ${selectedOrder.phoneNumber}`}
        />

        {/* Address card */}
        {/* <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 mb-5 max-w-lg">
            <label className="block font-semibold text-sm text-gray-700 mb-2">
                Select Address:
            </label>
            <select
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                disabled={isFinalStageSelection}
                className={`w-full p-2.5 border border-gray-300 rounded-lg text-sm mb-3 focus:outline-none focus:border-black transition-colors
                    ${isFinalStageSelection ? "bg-gray-100 cursor-not-allowed" : "bg-gray-50 cursor-pointer"}`}
            >
                {addressOptions.length === 0 ? (
                    <option value="">None</option>
                ) : (
                    addressOptions.map((addr, index) => (
                        <option key={index} value={addr}>{addr}</option>
                    ))
                )}
            </select>
            <textarea
                id="address"
                name="address"
                rows="3"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Enter your full address"
                required
                disabled={isFinalStageSelection}
                className={`w-full p-2.5 border border-gray-300 rounded-lg text-sm resize-none focus:outline-none focus:border-black transition-colors
                    ${isFinalStageSelection ? "bg-gray-100 cursor-not-allowed" : "bg-white"}`}
            />
        </div> */}

        {/* Products table */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 mb-5">
            <OrderProductsTable
                rows={rows}
                suggestions={suggestions}
                handleChange={handleChange}
                handleSelectSuggestion={handleSelectSuggestion}
                handleAddRow={handleAddRow}
                handleSubmit={handleSubmit}
                showSubmitButton={showSubmitButton}
                handleProductDelete={handleProductDelete}
                showDeletePopup={showDeletePopup}
                deleteIndex={deleteIndex}
                setShowDeletePopup={setShowDeletePopup}
                reasons={reasons}
                selectedReasons={selectedReasons}
                setSelectedReasons={setSelectedReasons}
                selectedOrder={selectedOrder}
                setDeleteIndex={setDeleteIndex}
                activeSuggestionIndex={activeSuggestionIndex}
                setActiveSuggestionIndex={setActiveSuggestionIndex}
            />
        </div>

        {/* Rejection reason */}
        {selectedOrder?.status === "reject" && selectedOrder?.rejectReason && (
            <div className="text-red-600 italic text-sm bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
                <strong>Rejection Reason:</strong> {selectedOrder.rejectReason}
            </div>
        )}

        {/* Status update section */}
        {selectedOrder.status !== "completed" && selectedOrder.status !== "reject" && (
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 mt-5">
                <p className="font-semibold text-base text-gray-800 mb-3">Update Status:</p>
                <div className="flex items-center gap-3 flex-wrap">
                    {getNextStatuses(selectedOrder.status).map((status) => {
                        const isReject = status === "reject";
                        const label = status.charAt(0).toUpperCase() + status.slice(1);

                        return (
                            <button
                                key={status}
                                onClick={() => {
                                    setNewStatus(status);
                                    if (isReject) {
                                        setIsRejectModalOpen(true);
                                        return;
                                    }
                                    updateOrderStatus(status);
                                }}
                                className={`px-4 py-2 text-white rounded-lg font-medium text-sm shadow-sm transition-colors
                                ${isReject
                                        ? "bg-red-600 hover:bg-red-700"
                                        : newStatus === status
                                            ? "bg-green-600 hover:bg-green-700"
                                            : "bg-blue-600 hover:bg-blue-700"
                                    }`}
                            >
                                {label}
                            </button>
                        );
                    })}
                </div>

                {/* Driver section */}
                {(newStatus === "delivery pickup" || selectedOrder.status === "delivery pickup") && (
                    <div className="mt-4 p-4 border border-gray-200 rounded-xl bg-gray-50">
                        {!useNewDriver ? (
                            <div className="flex items-center gap-3 flex-wrap">
                                <select
                                    className="popup-section select p-2.5 w-full sm:w-2/5 rounded-lg border border-gray-300 text-sm bg-white focus:outline-none focus:border-black"
                                    value={driverId}
                                    onChange={(e) => setDriverId(e.target.value)}
                                >
                                    <option value="">Select Driver</option>
                                    {driverList.map((driver) => (
                                        <option key={driver._id} value={driver._id}>
                                            {driver.name} - {driver.mobile}
                                        </option>
                                    ))}
                                </select>
                                <button
                                    type="button"
                                    onClick={() => setUseNewDriver(true)}
                                    className="px-4 py-2 font-semibold bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 transition-colors"
                                >
                                    + Add New Driver
                                </button>
                            </div>
                        ) : (
                            <div className="flex gap-3 flex-wrap">
                                <input
                                    type="text"
                                    placeholder="Driver Name"
                                    value={driverName}
                                    onChange={(e) => setDriverName(e.target.value)}
                                    className="p-2.5 w-full sm:w-2/5 rounded-lg border border-gray-300 text-sm focus:outline-none focus:border-black"
                                />
                                <input
                                    type="text"
                                    placeholder="Mobile Number"
                                    value={driverMobile}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, '');
                                        if (val.length <= 10) setDriverMobile(val);
                                    }}
                                    maxLength={10}
                                    pattern="\d{10}"
                                    className="p-2.5 w-full sm:w-2/5 rounded-lg border border-gray-300 text-sm focus:outline-none focus:border-black"
                                />
                                <button
                                    type="button"
                                    onClick={() => setUseNewDriver(false)}
                                    className="px-4 py-2 font-semibold bg-red-600 text-white rounded-lg text-sm hover:bg-red-700 transition-colors"
                                >
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        )}

        <OrderStatusHistory statusHistory={statusHistory} />
        {isRejectModalOpen && (
            <div className="order-popup-overlay">
                <div className="order-popup-box">
                    <div className="popup-header">
                        <h3>Reject Order: {selectedOrder.orderId}</h3>
                        <button className="close-btn" onClick={closeRejectModal}>
                            ✖
                        </button>
                    </div>

                    <div className="popup-section">
                        <label className="popup-label">Select Reason for Rejection:</label>
                        <select
                            className="popup-select"
                            value={selectedRejectReason}
                            onChange={(e) => setSelectedRejectReason(e.target.value)}
                        >
                            <option value="">-- Select Reason --</option>
                            {rejectReasons.map((reason, idx) => (
                                <option key={idx} value={reason}>
                                    {reason}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="popup-button-row">
                        <button
                            className="popup-btn danger"
                            onClick={() => {
                                if (!selectedRejectReason) return;
                                updateOrderStatus("reject", selectedRejectReason);
                                closeRejectModal();
                            }}
                            disabled={!selectedRejectReason}
                            style={!selectedRejectReason ? { opacity: 0.6, cursor: "not-allowed" } : {}}
                        >
                            Confirm Reject
                        </button>
                        <button className="popup-btn secondary" onClick={closeRejectModal}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        )}
        </div>
    );
};

export default OrderDetailView;
